/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import {useSelector} from 'react-redux'
import {isEmpty, isLoaded} from 'react-redux-firebase'
import CustomerDataReady from './customer-data-ready'

const AuthIsLoaded = ({children}) => {
  const auth = useSelector(state => state.firebase.auth)

  // Auth payload is being loaded from Firebase.
  if (!isLoaded(auth)) return null

  // User is not authenticated. If the destination route is protected,
  // user will be redirected to the login page, otherwise will continue
  // to the desired unrestricted route.
  if (isLoaded(auth) && isEmpty(auth)) return children

  // User is authenticated.
  // Checking if there's an associated customer document in the db.
  return <CustomerDataReady uid={auth.uid}>{children}</CustomerDataReady>
}

export default AuthIsLoaded
